/** @format */

import * as actionTypes from "../types";

const initialState = {
  error: null,
  isLoading: false,
  cart: {},
  sfl: {},
  isError500: false
};

const checkout = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CART:
      return {
        ...state,
        cart: action.payload.cart,
      };

    case actionTypes.SET_SFL:
      return {
        ...state,
        sfl: action.payload.sfl,
      };

    case actionTypes.SET_ERROR500:
      return {
        ...state,
        isError500: action.payload.isError500,
      };  

    default:
      return state;
  }
};
export default checkout;
